import { SocialNetwork } from '../models/social-network.model';

export class DeleteSocialNetwork {
    static readonly type = '[User] DeleteSocialNetwork';

    constructor(public payload: SocialNetwork) {}
}
